import type { VehicleShapeDefinition } from './vehicleShape';

/**
 * Wheel loader with high grapple
 * Similar to front grapple but with grapple positioned higher
 */
export const wheelLoaderHighGrappleShape: VehicleShapeDefinition = {
  vehicle: 'wheel_loader_high_grapple',
  coordinateSystem: '2D',
  unit: 'normalized_percent',
  polygons: {
    rear_wheel_left: [
      [15, 90],
      [35, 90],
      [35, 130],
      [15, 130],
    ],

    rear_wheel_right: [
      [65, 90],
      [85, 90],
      [85, 130],
      [65, 130],
    ],

    front_wheel_left: [
      [15, 40],
      [35, 40],
      [35, 68],
      [15, 68],
    ],

    front_wheel_right: [
      [65, 40],
      [85, 40],
      [85, 68],
      [65, 68],
    ],

    lower_body: [
      [30, 85],
      [70, 85],
      [70, 140],
      [30, 140],
    ],

    upper_body: [
      [30, 45],
      [70, 45],
      [70, 75],
      [30, 75],
    ],

    driver_cabin: [
      [35, 65],
      [65, 65],
      [65, 105],
      [35, 105],
    ],

    // High grapple - positioned higher than front grapple
    grapple: [
      [10, 20],
      [50, 0],
      [90, 20],
      [50, 14],
    ],

    // Grapple arm connecting to body
    grapple_arm: [
      [40, 14],
      [60, 14],
      [60, 45],
      [40, 45],
    ],
  },
  colorConfig: {
    lower_body: { type: 'dynamic' }, // Uses vehicle color
    upper_body: { type: 'dynamic' }, // Uses vehicle color
    front_wheel_left: { type: 'fixed', color: '#000000' },
    front_wheel_right: { type: 'fixed', color: '#000000' },
    rear_wheel_left: { type: 'fixed', color: '#000000' },
    rear_wheel_right: { type: 'fixed', color: '#000000' },
    driver_cabin: { type: 'fixed', color: '#000000' },
    grapple: { type: 'fixed', color: '#000000' },
    grapple_arm: { type: 'fixed', color: '#000000' },
  },
};
